import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Button } from 'next-common-lib';
import i18n from 'i18n';
import * as wizardActions from 'redux/ducks/common/wizardDuck';

export const PopConfirmButton = ({ confirmAction, cancelAction }) => {
  const dispatch = useDispatch();
  const isShowProgressPopup = useSelector(state => state.popup.ProgressPopup.isShow);
  const onCancelClick = () => {
    cancelAction();
    dispatch(wizardActions.closePopup());
  };

  return (
    <div className="btn-set al-right">
      <div className="btn-group">
        <Button
          componentType="solid"
          className="secondary"
          size="md"
          label={i18n.t('EM_T_CANCEL')}
          onClick={onCancelClick}
        />
        <Button
          componentType="solid"
          className="primary"
          size="md"
          label={i18n.t('EM_T_SAVE')}
          onClick={confirmAction}
          disabled={isShowProgressPopup}
        />
      </div>
    </div>
  );
};
PopConfirmButton.propTypes = { confirmAction: PropTypes.func.isRequired, cancelAction: PropTypes.func };
PopConfirmButton.defaultProps = { cancelAction: () => {} };
export default PopConfirmButton;
